export const assets = {
  logoIcon: "/assets/images/logo-icon.png",
  logo: "/assets/images/logo.png",
  loginWallpapers: [
    "/assets/images/boxxy_login_hero_images/building-with-green-facade-plants-side-bosco-verticale-vertical-forest-milan.webp",
    "/assets/images/boxxy_login_hero_images/exquisite-residences-3d-renderings-luxury-apartment-buildings.webp",
    "/assets/images/boxxy_login_hero_images/low-angle-view-buildings-against-clear-sky.webp",
    "/assets/images/boxxy_login_hero_images/il-bosco-verticale-di-milano-italia.webp",
    "/assets/images/boxxy_login_hero_images/building-with-large-glass-door-that-says-word-it.webp",
    "/assets/images/boxxy_login_hero_images/low-angle-view-building-against-sky.webp",
    "/assets/images/boxxy_login_hero_images/entrance-hall-apartment-with-staircase.webp",
    "/assets/images/boxxy_login_hero_images/downtown-modern-building-spring-sky-colors-chilean-city.webp",
    "/assets/images/boxxy_login_hero_images/contemporary-high-rise-urban-building-with-geometric-design-against-cloudless-blue-sky-sunny-day.webp",
    "/assets/images/boxxy_login_hero_images/contemporary-apartment-building-with-floor-ceiling-windows-seen-berlin-germany.webp",
    "/assets/images/boxxy_login_hero_images/construction-vertical-gardens-milan.webp",
  ],
};
